import { PublicClientApplication, LogLevel, Configuration } from '@azure/msal-browser';

const redirectBase = `${window.location.origin}${import.meta.env.BASE_URL}`; // '/payments/' aware

const signInWithMicrosoftEnabled = typeof import.meta.env.VITE_MSAL_CLIENT_ID !== 'undefined';

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID as string,
    authority: 'https://login.microsoftonline.com/organizations', // individuals
    redirectUri: `${redirectBase}sso/microsoft`,
    postLogoutRedirectUri: redirectBase,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Error,
      loggerCallback: () => {
        // no-op, keep logs minimal
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
// Ensure MSAL is initialized before any API calls (required in msal-browser v3)
export const msalInitialized = signInWithMicrosoftEnabled
  ? msalInstance.initialize()
  : Promise.resolve(true);
